/**
 *
 * @module accessToken
 *
 */

import Services from './../services/entry';

/**
 *
 * @class AccessToken
 *
 */
export default class AccessToken extends Services.Token.AccessToken {}



// WEBPACK FOOTER //
// ./src/token/accessToken.js